export default __webpack_public_path__ + "static/media/avatar-5.c754f2b4.png";